import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Container, Row, Col } from "reactstrap"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faXTwitter, faInstagram, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons"
import ContentMax from "components/shared/ContentMax"
import { media } from "utils/Media"
import Button from "components/shared/Button"

const ContainerStyled = styled(Container)`
	padding-top: 3rem;
	padding-bottom: 3rem;
	background-color: ${props => props.theme.colors.white};

	h3 {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		text-transform: uppercase;
		color: ${props => props.theme.colors.tertiary};
		font-family: ${props => props.theme.font.family.body};
		//font-style: italic;
		font-weight: 400;
		font-size: 2.5rem;
		padding-bottom: 1rem;
		text-align: center;
		
		@media ${media.md} {
			font-size: 3.25rem;
			padding-bottom: 2rem;
		}
		
		a {
			color: ${props => props.theme.colors.tertiary};
			padding: .75rem;
			font-size: 1.5rem;
			padding-top: 1rem;
			
			@media ${media.sm} {
				font-size: 2rem;
			}
			
			@media ${media.lg} {
				font-size: 2.25rem;
				padding-left: 2rem;
			}
			
			svg {
				max-height: 37px;
			}
			
			&:hover {
				color: ${props => props.theme.colors.secondary};
			}
		}
	}
`

const ImageWrap = styled.div`
	position: relative;
	line-height: 0;
`

const SocialImages = (props) => {
	const [activeSet, setActiveSet] = useState(0)

	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { 
		socialImages,
		socialFacebookGlobal,
		socialTwitterGlobal,
		socialInstagramGlobal,
		socialYoutubeGlobal,
		socialTiktokGlobal
	} = data.allWp?.edges[0]?.node?.options?.acfOptions

	const rotateImages = (e) => {
		e.preventDefault();
		const set = activeSet + 1
		setActiveSet(set === socialImages.length ? 0 : set)
	}

	const imageSets = socialImages && socialImages.map((images, i) => {
		if (activeSet === i) {
			return(
				<Row key={i}>
					{images.images && images.images.map((image, i) => {
						return(
							<Col key={i} xs={6} md={3} className="pb-3 pb-md-0">
								<ImageWrap>
									<GatsbyImage
										image={image.localFile.childImageSharp.gatsbyImageData}
										alt={image.altText}
									/>
								</ImageWrap> 
							</Col>
						)
					})}
				</Row>
			)
		} else return ""
	})

	return(
		<ContainerStyled fluid>
			<ContentMax>
				<Row className="justify-content-center">
					<Col xs="auto">
						<h3>
							Follow us
							<div className="w-100 d-lg-none" />
							{socialFacebookGlobal &&
								<a href={socialFacebookGlobal} target="_blank" rel="noopener noreferrer">
									<span className="sr-only">Facebook</span>
									<FontAwesomeIcon icon={faFacebookF} />
								</a>
							}
							{socialTwitterGlobal &&
								<a href={socialTwitterGlobal} target="_blank" rel="noopener noreferrer">
									<span className="sr-only">Twitter</span>
									<FontAwesomeIcon icon={faXTwitter} />
								</a>
							}
							{socialInstagramGlobal &&
								<a href={socialInstagramGlobal} target="_blank" rel="noopener noreferrer">
									<span className="sr-only">Instagram</span>
									<FontAwesomeIcon icon={faInstagram} />
								</a>
							}
							{socialYoutubeGlobal &&
								<a href={socialYoutubeGlobal} target="_blank" rel="noopener noreferrer">
									<span className="sr-only">Youtube</span>
									<FontAwesomeIcon icon={faYoutube} />
								</a>
							}
							{socialTiktokGlobal &&
								<a href={socialTiktokGlobal} target="_blank" rel="noopener noreferrer">
									<span className="sr-only">Tiktok</span>
									<FontAwesomeIcon icon={faTiktok} />
								</a>
							}
						</h3>
					</Col>
				</Row>

				{imageSets && 
					<>
						{imageSets}
						<div className="pt-4 pt-md-5 text-center">
							<Button href="#" onClick={rotateImages} color="primary">
								Show more
							</Button>
						</div>
					</>
				}
			</ContentMax>
		</ContainerStyled>
	)
}

export default SocialImages